import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["frame", "select"]
  static values = {
    previewUrl: String,
  }

  update() {
    if (!this.hasFrameTarget || !this.hasSelectTarget || !this.hasPreviewUrlValue) {
      return
    }

    const url = new URL(this.previewUrlValue, window.location.href)
    const listId = this.selectTarget.value

    if (listId) {
      url.searchParams.set("test_list_id", listId)
    } else {
      url.searchParams.delete("test_list_id")
    }

    this.frameTarget.src = url.toString()
  }
}
